export default __webpack_public_path__ + "static/media/icon-dashboard-ac.9e9d8b2e.png";